/* unplugin-vue-components disabled */import _toConsumableArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/img/filter.png';
var _hoisted_1 = {
  class: "patrol-scheme-page"
};
var _hoisted_2 = {
  class: "patrol-scheme-top"
};
var _hoisted_3 = {
  class: "footer-left"
};
var _hoisted_4 = {
  class: "footer-right"
};
var _hoisted_5 = {
  class: "popup-content"
};
var _hoisted_6 = {
  key: 0
};
var _hoisted_7 = {
  key: 1
};
var _hoisted_8 = {
  key: 2
};
var _hoisted_9 = {
  class: "popup-btn"
};
var _hoisted_10 = /*#__PURE__*/_createElementVNode("div", null, null, -1);
var _hoisted_11 = /*#__PURE__*/_createElementVNode("div", {
  class: "filter-top-title"
}, "更多筛选", -1);
var _hoisted_12 = {
  class: "filter-content"
};
var _hoisted_13 = /*#__PURE__*/_createElementVNode("div", {
  class: "filter-content-label"
}, "任务类型", -1);
var _hoisted_14 = {
  class: "filter-content"
};
var _hoisted_15 = /*#__PURE__*/_createElementVNode("div", {
  class: "filter-content-label"
}, "任务状态", -1);
var _hoisted_16 = {
  class: "filter-content"
};
var _hoisted_17 = /*#__PURE__*/_createElementVNode("div", {
  class: "filter-content-label"
}, "审核人", -1);
var _hoisted_18 = {
  class: "popup-btn filter-action-btn"
};
import { showToast } from 'vant';
import { useStore } from '@/store';
import { findUsers, delPatrolScheme, postPatrolScheme, patrolSchemeStatus } from '@/service/patrolScheme/index';
import CollapseList from './CollapseList.vue';
import './index.less';
import './common.less';
var __default__ = {
  name: 'PatrolScheme'
};
export default /*#__PURE__*/_defineComponent(_objectSpread(_objectSpread({}, __default__), {}, {
  setup: function setup(__props) {
    var taskTypeOption = [{
      dictCode: 1,
      dictValue: 1,
      dictlabel: '单次'
    }, {
      dictCode: 2,
      dictValue: 2,
      dictlabel: '每日'
    }, {
      dictCode: 3,
      dictValue: 3,
      dictlabel: '每月'
    }];
    var taskStatusOption = [{
      value: 0,
      text: '启用'
    }, {
      value: 1,
      text: '禁用'
    }];
    var router = useRouter();
    var store = useStore();
    var route = useRoute();
    var type = route.query.type;
    if (Number(type) == 0) {
      document.title = '巡检计划';
    } else {
      document.title = '保养计划';
    }
    var searchVal = ref('');
    var radioChecked = ref('');
    var customPopupType = ref();
    var filterModalShow = ref(false);
    // 任务类型
    var taskType = reactive({
      value: null,
      label: ''
    });
    //任务状态
    var taskStatus = reactive({
      value: null,
      label: ''
    });
    var showStatusPicker = ref(false);
    // 审核人
    var reviewedBy = ref('');
    var userList = ref([]);
    var oldScrollTop = ref(0);
    var loading = ref(true);
    var page = ref(1);
    var pageSize = ref(15);
    var totalPage = ref(1);
    var patrolSchemList = ref([]);
    var finished = ref(false);
    var listloading = ref(false);
    var taskItem = ref('');
    var modalShow = ref(false);
    var showTaskTypePicker = ref(false);
    var showUserPicker = ref(false);
    var scrollTop = computed(function () {
      return store.getters['patrolScheme/getScrollTop'];
    });
    var onRefresh = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              finished.value = false;
              _context.prev = 1;
              page.value = 1;
              _context.next = 5;
              return getList({
                assessorUserName: reviewedBy.value,
                inspectionTaskCode: taskType.value,
                useStatus: taskStatus.value,
                taskName: searchVal.value,
                taskType: type
              });
            case 5:
              showToast('刷新成功');
              loading.value = false;
              _context.next = 13;
              break;
            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](1);
              showToast('刷新失败');
              loading.value = false;
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 9]]);
      }));
      return function onRefresh() {
        return _ref.apply(this, arguments);
      };
    }();
    var goToDetail = function goToDetail(item) {
      router.push({
        path: '/patrolScheme/detail',
        query: {
          id: item.inspectionTaskId,
          ruleId: item.inspectionTaskRuleId
        }
      });
    };
    var onFilterSearch = function onFilterSearch() {
      filterModalShow.value = true;
    };
    var onSearchVal = function onSearchVal(value) {
      finished.value = false;
      page.value = 1;
      getList({
        taskName: value,
        assessorUserName: reviewedBy.value,
        inspectionTaskCode: taskType.value,
        useStatus: taskStatus.value,
        taskType: type
      });
    };
    var onClear = function onClear(value) {
      finished.value = false;
      page.value = 1;
      getList({
        taskName: value,
        assessorUserName: reviewedBy.value,
        inspectionTaskCode: taskType.value,
        useStatus: taskStatus.value,
        taskType: type
      });
    };
    var radioClick = function radioClick(type, item) {
      modalShow.value = true;
      taskItem.value = item;
      customPopupType.value = type;
    };
    // 删除按钮
    var onDelBtn = function onDelBtn(item, index) {
      taskItem.value = _objectSpread(_objectSpread({}, item), {}, {
        index: index
      });
      modalShow.value = true;
      customPopupType.value = '2';
    };
    var onCancel = function onCancel() {
      modalShow.value = false;
      radioChecked.value = '';
    };
    var onOk = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res, _res, message;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(unref(customPopupType) === '2')) {
                _context2.next = 7;
                break;
              }
              _context2.next = 3;
              return delPatrolScheme({
                inspectionTaskRuleId: taskItem.value.inspectionTaskRuleId || '',
                inspectionTaskId: taskItem.value.inspectionTaskId || ''
              });
            case 3:
              res = _context2.sent;
              if (res.status == '1') {
                showToast.success("\u5220\u9664\u6210\u529F");
                unref(patrolSchemList).splice(taskItem.value.index, 1);
              } else {
                showToast("\u5220\u9664\u5931\u8D25");
              }
              _context2.next = 13;
              break;
            case 7:
              _context2.next = 9;
              return patrolSchemeStatus({
                useStatus: Number(unref(customPopupType)),
                inspectionTaskRuleId: taskItem.value.inspectionTaskRuleId || '',
                inspectionTaskId: taskItem.value.inspectionTaskId || ''
              });
            case 9:
              _res = _context2.sent;
              message = '';
              if (unref(customPopupType) === '1') {
                message = '禁用';
              } else if (unref(customPopupType) === '0') {
                message = '启用';
              }
              if (_res.status == '1') {
                showToast.success("".concat(message, "\u6210\u529F"));
                patrolSchemList.value = unref(patrolSchemList).map(function (item) {
                  var itemObj = _objectSpread({}, item);
                  if (item.inspectionTaskRuleId === unref(taskItem).inspectionTaskRuleId) {
                    itemObj.useStatus = Number(unref(customPopupType));
                  }
                  return itemObj;
                });
                radioChecked.value = '';
              } else {
                showToast("".concat(message, "\u5931\u8D25"));
              }
            case 13:
              modalShow.value = false;
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function onOk() {
        return _ref2.apply(this, arguments);
      };
    }();
    var onRest = function onRest() {
      taskStatus.label = '';
      taskStatus.value = null;
      taskType.label = '';
      taskType.value = null;
      reviewedBy.value = '';
    };
    var onFilterOk = function onFilterOk() {
      filterModalShow.value = false;
      finished.value = false;
      page.value = 1;
      getList({
        assessorUserName: reviewedBy.value,
        inspectionTaskCode: taskType.value,
        useStatus: taskStatus.value,
        taskName: searchVal.value,
        taskType: type
      });
    };
    var onFilterCancel = function onFilterCancel() {
      filterModalShow.value = false;
    };
    var onStatusConfirm = function onStatusConfirm(value) {
      taskStatus.value = value.value;
      taskStatus.label = value.text;
      showStatusPicker.value = false;
    };
    var onUserConfirm = function onUserConfirm(value) {
      reviewedBy.value = value.userName;
      showUserPicker.value = false;
    };
    var onTaskTypeConfirm = function onTaskTypeConfirm(value) {
      showTaskTypePicker.value = false;
      taskType.value = value.dictCode;
      taskType.label = value.dictlabel;
    };
    var onScrollHandle = function onScrollHandle(event) {
      // 滚动条距文档顶部的距离
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      // 滚动条滚动的距离
      var scrollStep = scrollTop - oldScrollTop.value;
      // 更新——滚动前，滚动条距文档顶部的距离
      oldScrollTop.value = scrollTop;
      //变量windowHeight是可视区的高度
      var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
      //变量scrollHeight是滚动条的总高度
      var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      store.commit('patrolScheme/setScrollTop', scrollTop);
    };
    var onLoad = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              listloading.value = true;
              _context3.next = 4;
              return getList({
                assessorUserName: reviewedBy.value,
                inspectionTaskCode: taskType.value,
                useStatus: taskStatus.value,
                taskName: searchVal.value,
                taskType: type
              });
            case 4:
              listloading.value = false;
              _context3.next = 11;
              break;
            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3["catch"](0);
              listloading.value = false;
              finished.value = true;
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[0, 7]]);
      }));
      return function onLoad() {
        return _ref3.apply(this, arguments);
      };
    }();
    var getList = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(params) {
        var _newList, res, data, records, pages, newList, newRecords;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              listloading.value = true;
              _context4.prev = 1;
              _context4.next = 4;
              return postPatrolScheme({
                pageIndex: page.value,
                pageSize: pageSize.value,
                t: params
              });
            case 4:
              res = _context4.sent;
              data = res.data;
              records = data.records, pages = data.pages;
              totalPage.value = pages;
              newList = _toConsumableArray(patrolSchemList.value);
              newRecords = records.map(function (el) {
                var newEl = _objectSpread(_objectSpread({}, el), {}, {
                  dictLabel: ''
                });
                patrolSchemList.value.forEach(function (item) {
                  if (el.deviceTypeCode === item.dictValue) {
                    newEl.dictLabel = item.dictLabel;
                  }
                });
                return newEl;
              });
              if (page.value === 1) {
                newList = [];
              }
              (_newList = newList).push.apply(_newList, _toConsumableArray(newRecords));
              if (page.value >= pages) {
                finished.value = true;
              }
              page.value = page.value + 1;
              patrolSchemList.value = newList;
              listloading.value = false;
              return _context4.abrupt("return", Promise.resolve());
            case 19:
              _context4.prev = 19;
              _context4.t0 = _context4["catch"](1);
              listloading.value = false;
              finished.value = true;
              return _context4.abrupt("return", Promise.reject());
            case 24:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[1, 19]]);
      }));
      return function getList(_x) {
        return _ref4.apply(this, arguments);
      };
    }();
    onActivated(function () {
      document.documentElement.scrollTop = scrollTop.value;
    });
    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      var data, list;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            // 监听页面滚动事件
            document.documentElement.scrollTop = 0;
            window.addEventListener('scroll', onScrollHandle, {
              passive: true
            });
            getList({
              taskType: type
            });
            _context5.next = 5;
            return findUsers();
          case 5:
            data = _context5.sent;
            if (Array.isArray(data)) {
              list = data || [];
              userList.value = list;
            }
          case 7:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    })));
    onUnmounted(function () {
      window.removeEventListener('scroll', onScrollHandle);
    });
    return function (_ctx, _cache) {
      var _component_van_search = _resolveComponent("van-search");
      var _component_van_radio = _resolveComponent("van-radio");
      var _component_van_radio_group = _resolveComponent("van-radio-group");
      var _component_van_button = _resolveComponent("van-button");
      var _component_van_list = _resolveComponent("van-list");
      var _component_van_popup = _resolveComponent("van-popup");
      var _component_van_field = _resolveComponent("van-field");
      var _component_van_picker = _resolveComponent("van-picker");
      var _component_van_pull_refresh = _resolveComponent("van-pull-refresh");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_search, {
        modelValue: _unref(searchVal),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _isRef(searchVal) ? searchVal.value = $event : null;
        }),
        onSearch: onSearchVal,
        onClear: onClear,
        "show-action": "",
        placeholder: "搜索计划名称"
      }, {
        action: _withCtx(function () {
          return [_createElementVNode("div", {
            class: "right-filter"
          }, [_createElementVNode("div", {
            onClick: onFilterSearch,
            class: "filter-text"
          }, "筛选"), _createElementVNode("img", {
            onClick: onFilterSearch,
            src: _imports_0
          })])];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createVNode(_component_van_pull_refresh, {
        modelValue: _unref(loading),
        "onUpdate:modelValue": _cache[17] || (_cache[17] = function ($event) {
          return _isRef(loading) ? loading.value = $event : null;
        }),
        onRefresh: onRefresh
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_van_list, {
            loading: _unref(listloading),
            "onUpdate:loading": _cache[2] || (_cache[2] = function ($event) {
              return _isRef(listloading) ? listloading.value = $event : null;
            }),
            "immediate-check": false,
            finished: _unref(finished),
            "finished-text": "没有更多了",
            onLoad: onLoad
          }, {
            default: _withCtx(function () {
              return [_createVNode(CollapseList, {
                listData: _unref(patrolSchemList)
              }, {
                footer: _withCtx(function (_ref6) {
                  var item = _ref6.item,
                    index = _ref6.index;
                  return [_createElementVNode("div", _hoisted_3, [_createVNode(_component_van_radio_group, {
                    modelValue: _unref(radioChecked),
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                      return _isRef(radioChecked) ? radioChecked.value = $event : null;
                    }),
                    direction: "horizontal"
                  }, {
                    default: _withCtx(function () {
                      return [item.useStatus == 1 ? (_openBlock(), _createBlock(_component_van_radio, {
                        key: 0,
                        name: "0",
                        "icon-size": "16",
                        onClick: function onClick() {
                          return radioClick('0', item);
                        }
                      }, {
                        default: _withCtx(function () {
                          return [_createTextVNode(" 启用 ")];
                        }),
                        _: 2
                      }, 1032, ["onClick"])) : _createCommentVNode("", true), item.useStatus == 0 ? (_openBlock(), _createBlock(_component_van_radio, {
                        key: 1,
                        name: "1",
                        "icon-size": "16",
                        onClick: function onClick() {
                          return radioClick('1', item);
                        }
                      }, {
                        default: _withCtx(function () {
                          return [_createTextVNode(" 禁用 ")];
                        }),
                        _: 2
                      }, 1032, ["onClick"])) : _createCommentVNode("", true)];
                    }),
                    _: 2
                  }, 1032, ["modelValue"])]), _createElementVNode("div", _hoisted_4, [item.useStatus == 1 ? (_openBlock(), _createBlock(_component_van_button, {
                    key: 0,
                    plain: "",
                    type: "primary",
                    class: "footer-user-action",
                    onClick: function onClick() {
                      return onDelBtn(item, index);
                    }
                  }, {
                    default: _withCtx(function () {
                      return [_createTextVNode(" 删除 ")];
                    }),
                    _: 2
                  }, 1032, ["onClick"])) : _createCommentVNode("", true), _createVNode(_component_van_button, {
                    type: "primary",
                    onClick: function onClick() {
                      return goToDetail(item);
                    },
                    class: "footer-user-action"
                  }, {
                    default: _withCtx(function () {
                      return [_createTextVNode(" 详情 ")];
                    }),
                    _: 2
                  }, 1032, ["onClick"])])];
                }),
                _: 1
              }, 8, ["listData"])];
            }),
            _: 1
          }, 8, ["loading", "finished"]), _createVNode(_component_van_popup, {
            show: _unref(modalShow),
            "onUpdate:show": _cache[3] || (_cache[3] = function ($event) {
              return _isRef(modalShow) ? modalShow.value = $event : null;
            }),
            position: "bottom",
            class: "filter-modal-show",
            onClose: onCancel
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_5, [_unref(customPopupType) === '1' ? (_openBlock(), _createElementBlock("span", _hoisted_6, "确定要禁用吗？")) : _createCommentVNode("", true), _unref(customPopupType) === '0' ? (_openBlock(), _createElementBlock("span", _hoisted_7, "确定要启用吗？")) : _createCommentVNode("", true), _unref(customPopupType) === '2' ? (_openBlock(), _createElementBlock("span", _hoisted_8, "确定要删除吗？")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_van_button, {
                type: "default",
                onClick: onCancel
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode("取消")];
                }),
                _: 1
              }), _createVNode(_component_van_button, {
                type: "primary",
                onClick: onOk
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode("确定")];
                }),
                _: 1
              })])];
            }),
            _: 1
          }, 8, ["show"]), _createVNode(_component_van_popup, {
            show: _unref(filterModalShow),
            "onUpdate:show": _cache[16] || (_cache[16] = function ($event) {
              return _isRef(filterModalShow) ? filterModalShow.value = $event : null;
            }),
            position: "bottom",
            class: "filter-modal-show"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("div", {
                class: "filter-top"
              }, [_hoisted_10, _hoisted_11, _createElementVNode("div", {
                class: "filter-top-cancel",
                onClick: onFilterCancel
              }, "取消")]), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createVNode(_component_van_field, {
                modelValue: _unref(taskType).label,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
                  return _unref(taskType).label = $event;
                }),
                "is-link": "",
                readonly: "",
                placeholder: "请选择",
                onClick: _cache[5] || (_cache[5] = function ($event) {
                  return showTaskTypePicker.value = true;
                })
              }, null, 8, ["modelValue"]), _createVNode(_component_van_popup, {
                show: _unref(showTaskTypePicker),
                "onUpdate:show": _cache[7] || (_cache[7] = function ($event) {
                  return _isRef(showTaskTypePicker) ? showTaskTypePicker.value = $event : null;
                }),
                round: "",
                position: "bottom"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_van_picker, {
                    columns: taskTypeOption,
                    "columns-field-names": {
                      text: 'dictlabel',
                      values: 'dictValue'
                    },
                    onCancel: _cache[6] || (_cache[6] = function ($event) {
                      return showTaskTypePicker.value = false;
                    }),
                    onConfirm: onTaskTypeConfirm
                  })];
                }),
                _: 1
              }, 8, ["show"])]), _createElementVNode("div", _hoisted_14, [_hoisted_15, _createVNode(_component_van_field, {
                modelValue: _unref(taskStatus).label,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = function ($event) {
                  return _unref(taskStatus).label = $event;
                }),
                "is-link": "",
                readonly: "",
                placeholder: "请选择",
                onClick: _cache[9] || (_cache[9] = function ($event) {
                  return showStatusPicker.value = true;
                })
              }, null, 8, ["modelValue"]), _createVNode(_component_van_popup, {
                show: _unref(showStatusPicker),
                "onUpdate:show": _cache[11] || (_cache[11] = function ($event) {
                  return _isRef(showStatusPicker) ? showStatusPicker.value = $event : null;
                }),
                round: "",
                position: "bottom"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_van_picker, {
                    columns: taskStatusOption,
                    onCancel: _cache[10] || (_cache[10] = function ($event) {
                      return showStatusPicker.value = false;
                    }),
                    onConfirm: onStatusConfirm
                  })];
                }),
                _: 1
              }, 8, ["show"])]), _createElementVNode("div", _hoisted_16, [_hoisted_17, _createVNode(_component_van_field, {
                modelValue: _unref(reviewedBy),
                "onUpdate:modelValue": _cache[12] || (_cache[12] = function ($event) {
                  return _isRef(reviewedBy) ? reviewedBy.value = $event : null;
                }),
                "is-link": "",
                readonly: "",
                placeholder: "请选择",
                onClick: _cache[13] || (_cache[13] = function ($event) {
                  return showUserPicker.value = true;
                })
              }, null, 8, ["modelValue"]), _createVNode(_component_van_popup, {
                show: _unref(showUserPicker),
                "onUpdate:show": _cache[15] || (_cache[15] = function ($event) {
                  return _isRef(showUserPicker) ? showUserPicker.value = $event : null;
                }),
                round: "",
                position: "bottom"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_van_picker, {
                    columns: _unref(userList),
                    "columns-field-names": {
                      text: 'userName',
                      values: 'userName'
                    },
                    onCancel: _cache[14] || (_cache[14] = function ($event) {
                      return showUserPicker.value = false;
                    }),
                    onConfirm: onUserConfirm
                  }, null, 8, ["columns"])];
                }),
                _: 1
              }, 8, ["show"])]), _createElementVNode("div", _hoisted_18, [_createVNode(_component_van_button, {
                type: "default",
                onClick: onRest
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode("重置")];
                }),
                _: 1
              }), _createVNode(_component_van_button, {
                type: "primary",
                onClick: onFilterOk
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode("确定筛选")];
                }),
                _: 1
              })])];
            }),
            _: 1
          }, 8, ["show"])];
        }),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
}));